<template>
    <component
        :is="headingTag"
        class="title-text"
        role="heading"
        :aria-level="level"
    >
        <slot />
    </component>
</template>

<script>

export default{
    name: 'TitleText',
    props: {
        level: {
            type: [String, Number],
            default: 1,
            validator: value => [1, 2, 3, 4, 5, 6].includes(Number(value))
        }
    },
    computed: {
        headingTag() {
            return `h${this.level}`;
        }
    }
};

</script>

<style scoped lang='scss'>
    .title-text {
        font-size: 1.25rem;
        font-weight: 700;
        color: #2F363E;
    }
</style>
